import { render, staticRenderFns } from "./SSR.vue?vue&type=template&id=846149f2&"
import script from "./SSR.vue?vue&type=script&lang=js&"
export * from "./SSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports